import { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AlternateAction = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const link = useMemo(() => {
    if (location.pathname === "/login") {
      return {
        title: t("layouts.labels.applyToJoinQuestion"),
        to: "/apply",
        buttonContent: t("layouts.labels.applyToJoin"),
      };
    }

    if (location.pathname.startsWith("/reset-password")) {
      return {
        title: t("layouts.labels.rememberedYourPassword"),
        to: "/login",
        buttonContent: t("layouts.labels.signIn"),
      };
    }

    return {
      title: t("layouts.labels.haveAnAccount"),
      to: "/login",
      buttonContent: t("layouts.labels.signIn"),
    };
  }, [location.pathname, t]);

  return (
    <div className="flex items-center justify-center gap-100">
      <span className="body-s-regular onboarding-alternate-action__text">
        {link.title}
      </span>

      <Link to={link.to} className="link-text">
        {link.buttonContent}
      </Link>
    </div>
  );
};

export default AlternateAction;
